export default "__VITE_ASSET__C9CF7yWc__"